import { useEffect } from "react";

/* Shell chrome shared by the landing-page auth consoles: backdrop plus the
 * window bar. The caller owns the body and the status text. */
export default function AuthTerminalModal({
  onClose,
  title = "bash — qv-auth",
  status,
  labelledBy,
  children,
}) {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <div
      dir="ltr"
      className="lp-term-backdrop fixed inset-0 z-60 flex items-start justify-center overflow-y-auto bg-black/70 px-4 py-10 backdrop-blur-[6px] sm:items-center sm:py-12"
      onMouseDown={(event) => {
        // Ignore drags that started inside the panel (text selection).
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className="lp-term lp-term-in relative my-auto w-full max-w-xl overflow-hidden rounded-lg"
      >
        <div className="lp-edge-sweep" />

        <div className="lp-term-rule flex items-center gap-3 border-b px-5 py-3.5">
          <span className="flex items-center gap-2">
            <i className="block h-3 w-3 rounded-full bg-[#e2564b]" />
            <i className="block h-3 w-3 rounded-full bg-[#ef9f27]" />
            <i className="block h-3 w-3 rounded-full bg-(--color-primary)" />
          </span>

          <span className="qv-mono truncate text-[12px] text-(--lp-term-dim)">
            {title}
          </span>

          {status && (
            <span className="qv-mono ml-auto flex items-center gap-2 whitespace-nowrap text-[10.5px] uppercase tracking-[0.18em] text-(--color-primary)">
              <span className="cyber-badge-dot" />
              {status}
            </span>
          )}
        </div>

        <div className="px-5 py-5 sm:px-7 sm:py-6">{children}</div>
      </div>
    </div>
  );
}
